import { useSelector } from "react-redux";
import { isProfileAccessible } from "../../services/UserService";
import {
  selectCallerAccounts,
  selectConfigValue,
} from "../../store/app-config/AppConfigSelectors";
import AppState from "../../store/AppState";
import InteractiveMenu from "../common/InteractiveMenu";

const MenuUI = ({ anchor, selected, handleClose }) => {
  const isMenuOpen = Boolean(anchor);
  const profileAccessible = isProfileAccessible();
  const callerAccounts = useSelector(selectCallerAccounts);
  const isProductAlertsEnabled = useSelector((state: AppState) =>
    selectConfigValue(state, "enableProductAlerts"),
  );
  const isProductBadgeEnabled = useSelector((state: AppState) =>
    selectConfigValue(state, "badgeOverlayEnabled"),
  );

  // Inline elements (not nested components) so the open menu is reconciled, not remounted.
  return (
    <div>
      {selected === "config-menu" && (
        <InteractiveMenu
          menuId="RenderConfigMenu"
          open={isMenuOpen}
          anchorEl={anchor}
          handleClose={handleClose}
          profileAccessible={profileAccessible}
          isProductAlertsEnabled={isProductAlertsEnabled}
          isProductBadgeEnabled={isProductBadgeEnabled}
          callerAccounts={callerAccounts}
        />
      )}
      {selected === "profile" && (
        <InteractiveMenu
          menuId="RenderMenu"
          open={isMenuOpen}
          anchorEl={anchor}
          handleClose={handleClose}
          profileAccessible={profileAccessible}
          callerAccounts={callerAccounts}
        />
      )}
      {selected === "recommendation" && (
        <InteractiveMenu
          menuId="RenderRecommendationMenu"
          open={isMenuOpen}
          anchorEl={anchor}
          handleClose={handleClose}
        />
      )}
      {selected === "create-new-rule" && (
        <InteractiveMenu
          menuId="RenderMenu"
          open={isMenuOpen}
          anchorEl={anchor}
          handleClose={handleClose}
          profileAccessible={profileAccessible}
          isProductAlertsEnabled={isProductAlertsEnabled}
          callerAccounts={callerAccounts}
        />
      )}
    </div>
  );
};

export default MenuUI;
